
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      let formData = new FormData(this.form);
      let sectionList = this.cartNotification.getSectionsToRender().map((section) => section.id);
      formData.append("sections",sectionList);
      formData.append("sections_url",window.location.pathname);
      var i = 1;
      if(typeof(savedDiceFiles) != 'undefined'){
        for(var key in savedDiceFiles){
          var files = savedDiceFiles[key];
          formData.append("properties[design-" + i + "]", files.mockupFile);
          formData.append("properties[_engravingFile-" + i + "]", files.engraving);
          i++;
        }
      }
      const request = new Request(`${routes.cart_add_url}`,{
              method: "post",
              headers: new Headers({
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            }),
            body:formData
      });

      fetch(request)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          this.cartNotification.renderContents(response);
          ttq.track('AddToCart');
          gtag('event', 'conversion', {
              'send_to': 'AW-10798894393/EXkPCI-p5f8CELmaqJ0o',
              'value': 1.0,
              'currency': 'USD'
          });

          gtag('event', 'add_to_cart');
          if (response.sku) {
            if (response.sku.endsWith('7set') || response.sku.endsWith('5eset')) {
              document.getElementById("ShowDiceVaultOpp").click()
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
